import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import BaseDialog from "../../../components/BaseDialog/BaseDialog";
import Content from "./components/Content";

import styles from "./styles";


const OtherAssetsModal = (props) => {
  const {
    classes,
    isCustomerApp,
    customerId,
    open,
    onClose,
    onUpdate,
    refresh,
    defaultTab,
    startDate,
    endDate,
    excludedPortfolios,
    withOtherAssets,
    withLiabilities,
  } = props;


  const isChanged = React.useRef(false);
  const refreshNeeded = React.useRef(false);
  const setChanged = React.useCallback((value) => {
    isChanged.current = true;
    if(value === 'depot') {
      refreshNeeded.current = true;
    }
  }, []);

  const handleClose = () => {
    onClose();
    if(refreshNeeded.current || isChanged.current){
      refreshNeeded.current ? refresh() : onUpdate();
      refreshNeeded.current = false;
      isChanged.current = false;
    }
  };

  return (
    <BaseDialog
      open={open}
      title={'Vermögensübersicht / Vermögen'}
      data-id={'other-assets-and-liabilities-popup'}
      handleClose={handleClose}
      maxWidth={false}
      PaperProps={{
        style: {
          maxWidth: "1480px", // Set custom max-width in pixels (as per design)
        },
      }}
      disableEnforceFocus
      customClasses={{
        dialogTitle: classes.dialogTitle,
        dialogContent: classes.dialogContent,
      }}
    >
      <Content
        allowSync={!isCustomerApp}
        customerId={customerId}
        defaultTab={defaultTab}
        setChanged={setChanged}
        startDate={startDate}
        endDate={endDate}
        excludedPortfolios={excludedPortfolios}
        withOtherAssets={withOtherAssets}
        withLiabilities={withLiabilities}
      />
    </BaseDialog>
  )
};

export default withStyles(styles)(OtherAssetsModal);